import { useTranslation } from 'react-i18next';
import type { i18n } from 'i18next';
import * as i18nextModule from 'i18next';
import en from './locales/en.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import es from './locales/es.json';
import it from './locales/it.json';

export const LIBRARY_I18N_NAMESPACE = 'qcomponents';

// Resolve the i18next instance across ESM and CJS module formats
const i18next = ((i18nextModule as unknown as { default?: i18n }).default ??
  i18nextModule) as i18n;

const locales: Record<string, Record<string, unknown>> = { en, fr, de, es, it };

// addResourceBundle is only available after i18next.init() runs.
// Register all locales immediately if already initialized, and again
// on the 'initialized' event to handle apps that init after import.
// deep=true, overwrite=false — consumer bundles always win.
function registerLocales() {
  for (const [lng, resources] of Object.entries(locales)) {
    i18next.addResourceBundle(
      lng,
      LIBRARY_I18N_NAMESPACE,
      resources,
      true,
      false,
    );
  }
}

i18next.on('initialized', registerLocales);
if (i18next.isInitialized) {
  registerLocales();
}

export const useLibraryTranslation = (): ReturnType<typeof useTranslation> =>
  useTranslation(LIBRARY_I18N_NAMESPACE);
